import { render, staticRenderFns } from "./reminder.vue?vue&type=template&id=314673b2&"
import script from "./reminder.vue?vue&type=script&lang=js&"
export * from "./reminder.vue?vue&type=script&lang=js&"
import style0 from "./reminder.vue?vue&type=style&index=0&id=314673b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports